import { IMedia, IProduct } from '../types';
import { AddToCartHandler } from '../types/shopThisLook';

/**
 * Executes the add-to-cart handler (if provided) and returns whether
 * the built-in confirmation screen should be shown.
 *
 * - Returns `true` → show the built-in confirmation screen.
 * - Returns `false` → the handler returned `{ skipConfirmation: true }`,
 *   so the widget should NOT show its confirmation screen
 *   (the client's own UI handles the next step).
 */
// eslint-disable-next-line import/prefer-default-export
export async function handleAddToCartAction(
  addToCartHandler: AddToCartHandler | undefined,
  product: IProduct,
  media: IMedia,
): Promise<boolean> {
  if (addToCartHandler) {
    const result = await Promise.resolve(addToCartHandler({ product, media }));
    if (result?.skipConfirmation) {
      return false;
    }
  }
  return true;
}
